export enum HypothesisChoice {
    DEPARTURE = 'departure',
    IFSE = 'ifse',
    PRIME = 'prime',
    GRADE = 'grade',
}
